export enum ConfigTypes {
  RcOv = 'rc/ov',
  Flex = 'flex',
  TExam = 'texam',
  Lunch = 'lunch',
  ExamCl = 'exam/cl',
  TExamCL = 'texam/cl',
  Exam = 'exam',
  OfficeUseOnly = 'office use only',
  DispenseRepair = 'dispense/repair',
}
